"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Spin = _interopRequireDefault(require("../Spin"));

var _component = require("../component");

var _styles = require("../styles");

var _Upload = _interopRequireDefault(require("./Upload"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var SPIN = function SPIN(color) {
  return _react.default.createElement("span", {
    style: {
      display: 'inline-block',
      marginRight: 8
    }
  }, _react.default.createElement(_Spin.default, {
    size: 10,
    name: "ring",
    color: color
  }));
};

var handleKeyDown = function handleKeyDown(e) {
  if (e.keyCode === 13) e.target.click();
};

var Progress =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Progress, _PureComponent);

  function Progress(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.state = {
      progress: -1
    };
    _this.handleError = _this.handleError.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleSuccess = _this.handleSuccess.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleProgress = _this.handleProgress.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleStart = _this.handleChange.bind(_assertThisInitialized(_assertThisInitialized(_this)), 0);
    _this.handleOver = _this.handleChange.bind(_assertThisInitialized(_assertThisInitialized(_this)), -1);
    _this.handleUpload = _this.handleUpload.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = Progress.prototype;

  _proto.handleChange = function handleChange(p) {
    this.setState({
      progress: p
    });
  };

  _proto.handleProgress = function handleProgress(file) {
    this.handleChange(file.process);
  };

  _proto.handleError = function handleError(error) {
    var onError = this.props.onError;
    if (onError) onError(error);
    this.handleOver();
  };

  _proto.handleSuccess = function handleSuccess() {
    var onSuccess = this.props.onSuccess;
    if (onSuccess) onSuccess.apply(void 0, arguments);
    this.handleOver();
  };

  _proto.handleUpload = function handleUpload(e) {
    var uploading = this.state.progress >= 0;
    if (uploading) e.stopPropagation();
  };

  _proto.renderLoadingView = function renderLoadingView(color) {
    var _this$props = this.props,
        placeholder = _this$props.placeholder,
        loading = _this$props.loading;
    return (0, _react.isValidElement)(loading) ? _react.default.createElement("span", null, loading) : _react.default.createElement("span", null, SPIN(color), typeof loading === 'string' ? loading : placeholder);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        placeholder = _this$props2.placeholder,
        type = _this$props2.type,
        others = _objectWithoutPropertiesLoose(_this$props2, ["placeholder", "type"]);

    var uploading = this.state.progress >= 0;
    var wrapperClassname = (0, _classnames.default)((0, _styles.uploadClass)('bprogress', others.disabled && 'disabled'), this.props.className, uploading ? (0, _styles.uploadClass)('uploading', "border-" + type) : (0, _styles.uploadClass)("bprogress-" + type));
    var style = {
      right: uploading ? 100 - this.state.progress + "%" : '100%'
    };
    return _react.default.createElement(_Upload.default, _extends({}, others, {
      onProgress: this.handleProgress,
      onStart: this.handleStart,
      showUploadList: false,
      onError: this.handleError,
      onSuccess: this.handleSuccess
    }), _react.default.createElement("div", {
      // eslint-disable-next-line
      tabIndex: this.props.disabled ? -1 : 0,
      className: wrapperClassname,
      onClick: this.handleUpload,
      onKeyDown: handleKeyDown
    }, uploading && _react.default.createElement("div", {
      style: style,
      className: (0, _styles.uploadClass)("bprogress-" + type, 'stream')
    }, this.renderLoadingView('#fff')), _react.default.createElement("span", null, uploading ? this.renderLoadingView() : placeholder)));
  };

  return Progress;
}(_component.PureComponent);

Progress.propTypes = {
  type: _propTypes.default.oneOf(['primary', 'success', 'info', 'warning', 'error', 'danger']),
  className: _propTypes.default.string,
  placeholder: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  loading: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  onSuccess: _propTypes.default.func,
  onError: _propTypes.default.func
};
Progress.defaultProps = {
  type: 'primary'
};
var _default = Progress;
exports.default = _default;